export const columns = [
  {
    field: "tracking_code",
    headerName: "CÓDIGO DE RESTREO",
    width: 180,
    resizable: false,
    sortable: false,
    renderHeader: (params) => <strong>CÓDIGO DE RASTREO</strong>,
  },
  {
    field: "recipient_name",
    headerName: "NOMBRE DEL DESTINATARIO",
    minWidth: 200,
    flex: 1,
    resizable: false,
    sortable: false,
    renderHeader: (params) => <strong>NOMBRE DEL DESTINATARIO</strong>,
  },
  {
    field: "business",
    headerName: "NEGOCIO",
    type: "string",
    minWidth: 100,
    flex: 1,
    resizable: false,
    sortable: false,
    headerAlign: "left",
    align: "left",
    renderHeader: (params) => <strong>NEGOCIO</strong>,
  },
  {
    field: "reasons_return",
    headerName: "MOTIVO",
    type: "string",
    minWidth: 100,
    flex: 1,
    resizable: false,
    sortable: false,
    headerAlign: "left",
    align: "left",
    renderHeader: (params) => <strong>MOTIVO</strong>
  }
];